// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PREGNANCY_NEWSLETTER_BANNER_TEXT = "Odeb\u00edrej t\u011bhotensk\u00fd newsletter! ";
export const PREGNANCY_NEWSLETTER_HINT = "Jsi t\u011bhotn\u00e1?";
